import { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";// Import AuthContext
import Account from '../components/Account'
import mtn from "../assets/mtn1.jpg";
import glo from "../assets/glo.jpg";
import airtel from "../assets/airtel.jpg";
import etisalat from "../assets/9mobile.jpg";
import "../styles/airtime.css";

const BuyAirtime = () => {
    const { buyAirtime, currentUser, fetchNotifications } = useContext(AuthContext);
    const [network, setNetwork] = useState("mtn");
    const [amount, setAmount] = useState("");
    const [error, setError] = useState('');
    const [phoneNumber, setPhoneNumber] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const [errorNetwork, setErrorNetwork] = useState("");
    const [errorPhone, setErrorPhone] = useState("");
    const [errorAmount, setErrorAmount] = useState("");

    const networkRef = useRef();
    const phoneRef = useRef();
    const amountRef = useRef();
    const [message, setMessage] = useState("");
    const navigate = useNavigate();


    const scrollToError = (ref) => {
        ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        let hasError = false;

        // Reset errors
        setErrorNetwork("");
        setErrorPhone("");
        setErrorAmount("");

        if (!network) {
            setErrorNetwork("Please select a network.");
            scrollToError(networkRef);
            hasError = true;
        }

        if (!phoneNumber) {
            setErrorPhone("Phone number is required.");
            scrollToError(phoneRef);
            hasError = true;
        } else if (phoneNumber.length !== 11) {
            setErrorPhone("Phone number must be 11 digits.");
            scrollToError(phoneRef);
            hasError = true;
        }

        if (!amount) {
            setErrorAmount("Please enter an amount.");
            scrollToError(amountRef);
            hasError = true;
        } else if (parseInt(amount) < 100 || parseInt(amount) > 10000) {
            setErrorAmount("Amount must be between ₦100 and ₦10,000.");
            scrollToError(amountRef);
            hasError = true;
        }

        if (hasError) return;

        navigate("/review", {
            state: {
                type: "airtime",
                details: {
                    network: network.toLowerCase(),
                    phoneNumber,
                    amount
                }
            }
        });
    };

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <div className="shadow-md airtime">
            <Account />

            {message && <p className="error-text text-center text-red-500">{message}</p>}

            <form onSubmit={handleSubmit} className="space-y-4 airtime-form">
                <div className="network-selection" ref={networkRef}>
                    <label className="network-label">Select Network Provider</label>

                    {screenWidth >= 800 ? (
                        <>
                            <select
                                value={network}
                                onChange={(e) => {
                                    setNetwork(e.target.value);
                                    setErrorNetwork(""); // clear error on change
                                }}
                                className="airtime-input styled-select w-full border rounded-md"
                            >
                                <option value="">-- Select Network --</option>
                                <option value="mtn">MTN</option>
                                <option value="glo">Glo</option>
                                <option value="airtel">Airtel</option>
                                <option value="9mobile">9mobile</option>
                            </select>
                            {errorNetwork && <p className="error-input">{errorNetwork}</p>}
                        </>
                    ) : (
                        <>
                            <div className="network-options">
                                {[
                                    { id: "mtn", src: mtn, alt: "MTN" },
                                    { id: "glo", src: glo, alt: "Glo" },
                                    { id: "airtel", src: airtel, alt: "Airtel" },
                                    { id: "9mobile", src: etisalat, alt: "9mobile" },
                                ].map(({ id, src, alt }) => (
                                    <img
                                        key={id}
                                        src={src}
                                        alt={alt}
                                        onClick={() => {
                                            setNetwork(id);
                                            setErrorNetwork(""); // clear error on click
                                        }}
                                        className={`network-image ${id === "mtn" ? "mtn-image" : ""} ${id === "glo" ? "glo-image" : ""} ${network === id ? "selected" : ""
                                            }`}
                                    />
                                ))}
                            </div>
                            {errorNetwork && <p className="error-input">{errorNetwork}</p>}
                        </>
                    )}
                </div>


                <div ref={phoneRef}>
                    <label className="network-label label-right">Enter Mobile Number</label>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={11}
                        value={phoneNumber}
                        onChange={(e) => {
                            const raw = e.target.value;
                            if (/^\d{0,11}$/.test(raw)) {
                                setPhoneNumber(raw);
                                setErrorPhone("");
                            }
                        }}
                        className="airtime-input w-full border rounded-md"
                        placeholder="Mobile Number"
                        required
                    />
                    {errorPhone && <p className="error-input">{errorPhone}</p>}
                </div>


                <div ref={amountRef}>
                    <label className="network-label">Select Amount</label>

                    <div className="preset-amounts">
                        {[100, 500, 1000, 2000].map((val) => (
                            <button
                                key={val}
                                type="button"
                                onClick={() => {
                                    setAmount(val);
                                    setErrorAmount("");
                                }}
                                className={`preset-btn ${amount == val ? "selected-amount" : ""}`}
                            >
                                ₦{val}
                            </button>
                        ))}
                    </div>

                    <div className="floating-label-group">
                        <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={amount}
                            onChange={(e) => {
                                const raw = e.target.value;
                                if (/^\d{0,5}$/.test(raw)) {
                                    setAmount(raw);
                                    setErrorAmount("");
                                }
                            }}
                            className="airtime-input"
                            required
                            placeholder="₦ Amount"
                        />
                        <label className={amount ? "filled" : ""}>₦ Amount</label>
                    </div>
                    {errorAmount && <p className="error-input">{errorAmount}</p>}
                </div>



                <button type="submit" className="bulk-btn" disabled={loading}>
                    {loading ? "Processing..." : "PROCEED"}
                </button>

            </form>

        </div>
    );
};

export default BuyAirtime;
